<template>
        <div class="alert alert-danger" role="alert">
            <p><strong>{{ parsedError.message }}</strong></p>
            <ul v-if="parsedError.errors">
                <li v-for="error in parsedError.errors">{{ error }}</li>
            </ul>
        </div>
</template>

<script>
export default {
    props: {
        error: {
            default: () => ({})
        }
    },
  /* eslint-disable */
    methods: {
        isJsonString: (str) => {
            try {
              JSON.parse(str);
            } catch (e) {
              return false;
            }
            return true;
        },
    },
    computed: {
        parsedError () {
            try {
                let errorMsg = this.error;
                if (this.isJsonString(this.error.message)) {
                  errorMsg = JSON.parse(this.error.message);
                }
                // default error parsed
                let errorDisplay = {
                    message: errorMsg.message || "We have encountered an unknown error while processing your registration. Please try again or contact support.", //default error for unknown or code 500 errors
                    errors: [],
                }

                // onboard service returns different error formats so we do some different processing below

                // here we use the message since it is appropriate and grab the errors array

                if (errorMsg.errors) {
                    // onboard v1
                    if (errorMsg.errors.constructor == Array) {
                      errorDisplay.errors = errorMsg.errors;
                    }
                    // onboard v2
                    if (errorMsg.errors.constructor == Object) {
                    errorDisplay.errors = [];
                        Object.keys(errorMsg.errors).forEach(function (key) {
                          let message = `Invalid field ${key}`;
                          switch (key) {
                            case "customer.name":
                              message = "Invalid or empty \"Name\" value";
                              break;
                            case "customer.industry":
                              message = "Invalid or empty \"Industry\" value";
                              break;
                            case "customer.country":
                              message = "Invalid or empty \"Country\" value";
                              break;
                            case "portal.domain":
                              message = "Invalid or empty \"Portal name\" value";
                              break;
                            case "user.email":
                              message = "Invalid or empty \"Email\" value";
                              break;
                            case "user.first_name":
                              message = "Invalid or empty \"First Name\" value";
                              break;
                            case "user.last_name":
                              message = "Invalid or empty \"Last Name\" value";
                              break;
                          }
                          errorDisplay.errors.push(message);
                        });
                    }
                }

                // onboard v1
                /*
                * here we don't use the message because it is too verbose.
                * we also have to map the errors array since it's the wrong format here
                */
                if (errorMsg.error) {
                    errorDisplay.message = "Invalid Input";
                    errorDisplay.errors = errorMsg.error.map( errorValue => {
                        return errorValue.message;
                    });
                }

                return errorDisplay;
            } catch (e) {
                return this.error;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Generic/FormError.vue